module.exports = __webpack_public_path__ + "static/media/appmobile2.a4a3a166.webp";